




















































































































import Vue from 'vue'
import { mapState } from 'vuex'

import VueContext from 'vue-context'
import 'vue-context/src/sass/vue-context.scss'
import { View } from '@/types/view'

import draggable from 'vuedraggable'

import NavViewLink from './nav-view-link.vue'
import NavViewGroup from './nav-view-group.vue'

import { Create, Patch } from '@/api/view'

interface DndMoved {
  newIndex: number
  oldIndex: number
  // eslint-disable-next-line
  element: View
}

interface DndChanged {
  moved: DndMoved
}

export default Vue.extend({
  name: 'NavView',
  components: {
    VueContext,
    NavViewGroup,
    NavViewLink,
    draggable,
  },
  data() {
    return {
      // eslint-disable-next-line
      contextTarget: null as any,
      selectedView: {} as View,
      expand: false,
    }
  },
  computed: {
    ...mapState('view', ['items']),
  },
  methods: {
    // ----------------------------------------------------------------------------------------------------------------
    // Operasi dengan database
    // ----------------------------------------------------------------------------------------------------------------
    async create(v: View) {
      return await Create(v)
    },

    async get() {
      await this.$store.dispatch('view/get')
    },

    async patch(id: number, v: View) {
      await Patch(id, v)
    },

    // eslint-disable-next-line
    handleViewContextMenu($event: any, v: View) {
      this.selectedView = v
      // eslint-disable-next-line
      ;(this as any).$refs.viewContextMenu.open($event)
      this.contextTarget = $event.currentTarget
    },

    async handleAddNewView() {
      const view: View = {
        id: 0,
        uid: '',
        title: 'New view',
        slug: '',
        icon: '',
        version: 0,
        groupId: 0,
        panels: [],
        attributes: {
          background: 'rgba(255,255,255,0)',
        },
        orderIndex: 0,
      }
      const { id } = await this.create(view)

      await this.get()

      this.$router.push({ path: `/design/view/${id}` })
    },

    async handleAddNewGroup() {
      const { id } = await this.$store.dispatch('view/createNewGroup')
      this.$router.push({ path: `/design/view/${id}` })
    },

    async handleDuplicateView() {
      const view: View = JSON.parse(JSON.stringify(this.selectedView))
      view.id = 0
      view.title = view.title + '_COPY'
      await this.create(view)
      await this.get()
    },

    async handleDeleteView() {
      // eslint-disable-next-line
      ;(this as any).$refs.deleteViewDialog.show()
    },
    async handlePreview() {
      // this.$router.push({
      //   path: `/v/${this.selectedView.uid}/${this.selectedView.slug}`,
      // })
      const win = window.open(
        `/v/${this.selectedView.uid}/${this.selectedView.slug}`,
        '_blank'
      )
      if (win) win.focus()
    },

    async patchView(view: View) {
      const { uid, slug } = await this.$store.dispatch('view/patch', {
        id: view.id,
        view,
      })
      if (
        this.$route.name === 'EditView' &&
        this.$route.params.uid &&
        this.$route.params.uid === uid
      ) {
        this.$router.push({ name: 'EditView', params: { uid, slug } })
      }
      this.contextTarget.classList.remove('rename')
    },

    async deleteView() {
      let nextPath = '#'
      if (parseInt(this.$route.params.id) === this.selectedView.id) {
        nextPath = '/design'
      }

      await this.$store.dispatch('view/delete', this.selectedView)

      // await this.$store.dispatch('view/get', this.selectedView)
      this.$router.push({ path: nextPath })
    },

    // ----------------------------------------------------------------------------------------------------------------
    // Drag & Drop
    // ----------------------------------------------------------------------------------------------------------------
    async onDndEnd(dnd: DndChanged) {
      const id = dnd.moved.element.id
      dnd.moved.element.orderIndex = dnd.moved.newIndex + 1
      await this.patch(id, dnd.moved.element)
      await this.get()
    },
  },
})
